import { Component, Input, OnInit, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { AttachmentService } from '../../../services/attachment.service';

@Component({
    selector: 'app-attachment-preview-modal',
    templateUrl: './attachment-preview-modal.component.html',
    styleUrls: ['./attachment-preview-modal.component.scss'],
    standalone: false
})
export class AttachmentPreviewModalComponent implements OnInit, OnDestroy {
  @Input() fileId!: number;
  @Input() fileName!: string;
  @Input() applicationId!: number;

  @ViewChild(PdfViewerComponent) pdfViewer!: PdfViewerComponent;

  fileBlob: Blob | null = null;
  fileUrl: string = '';
  fileType: string = '';
  isLoading: boolean = true;
  error: string | null = null;

  zoomLevel: number = 1;
  minZoom: number = 0.5;
  maxZoom: number = 3;

  pdfSrc: any = null;

  imageTransform: string = '';

  constructor(
    private modalRef: NzModalRef,
    private attachmentService: AttachmentService,
  ) { }

  ngOnInit(): void {
    this.loadFile();
  }

  ngOnDestroy(): void {
    if (this.fileUrl) {
      URL.revokeObjectURL(this.fileUrl);
    }
  }

  async loadFile(): Promise<void> {
    this.isLoading = true;
    this.error = null;
    this.attachmentService.getAttachment(this.applicationId, this.fileId).subscribe({
      next: (blob: Blob) => {
        this.setFileType(blob);
        this.isLoading = false;
      },
      error: err => {
        this.error = 'Ошибка при загрузке файла';
        this.isLoading = false;
        console.error('Error loading file:', err);
      }
    });
  };

  setFileType(blob: Blob): void {
    this.fileType = this.getFileType(this.fileName);
    this.fileBlob = blob;
    if (blob) {
      this.fileUrl = URL.createObjectURL(blob);
    }
    if (this.fileType === 'pdf') {
      this.pdfSrc = this.fileUrl;
    }
  }


  private getFileType(fileName: string): string {
    const extension = fileName.split('.').pop()?.toLowerCase();
    
    if (extension === 'pdf') {
      return 'pdf';
    } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension || '')) {
      return 'image';
    } else {
      return 'unsupported';
    }
  }

  zoomIn(): void {
    if (this.zoomLevel < this.maxZoom) {
      this.zoomLevel = Math.min(this.zoomLevel + 0.25, this.maxZoom);
      this.updateTransform();
    }
  }

  zoomOut(): void {
    if (this.zoomLevel > this.minZoom) {
      this.zoomLevel = Math.max(this.zoomLevel - 0.25, this.minZoom);
      this.updateTransform();
    }
  }

  resetZoom(): void {
    this.zoomLevel = 1;
    this.updateTransform();
  }

  private updateTransform(): void {
    if (this.fileType === 'image') {
      this.imageTransform = `scale(${this.zoomLevel})`;
    }
  }

  downloadFile(): void {
    if (this.fileBlob && this.fileUrl) {
      const link = document.createElement('a');
      link.href = this.fileUrl;
      link.download = this.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  closeModal(): void {
    this.modalRef.close();
  }

  isFileSupported(): boolean {
    return this.fileType === 'pdf' || this.fileType === 'image';
  }
}
